import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge configured for our custom type scale.
 *
 * The design system replaces Tailwind's default font sizes with named tokens
 * (`text-caption`, `text-label`, `text-body`, `text-heading`, …). Stock
 * tailwind-merge doesn't know these are font-sizes, so it conflated e.g.
 * `text-caption` with text-*color* utilities and dropped whichever came first.
 * That silently stripped `text-on-primary` from buttons whose size class
 * (`text-caption`) came last — rendering dark text on the dark primary fill.
 *
 * Registering the tokens in the `font-size` class group keeps font-size and
 * text-color as distinct groups, so both survive the merge.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['micro', 'caption', 'label', 'body', 'heading', 'title', 'display'] },
      ],
    },
  },
});

/**
 * Canonical className merger for the design system.
 * `cn('px-4', condition && 'px-6')` returns the correct merged class string
 * with Tailwind conflicts resolved (px-6 wins).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
